import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class OperationProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'operation'}
            title={ t('support.procedure.P21.title') }
            exportTitle={ t('support.procedure.P21.exportTitle') }
            exportFileName={'operation.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (OperationProcedure);
